import { render } from "./OrderSummaryChart.vue?vue&type=template&id=5c3985b6&scoped=true&ts=true"
import script from "./OrderSummaryChart.vue?vue&type=script&lang=ts"
export * from "./OrderSummaryChart.vue?vue&type=script&lang=ts"

import "./OrderSummaryChart.vue?vue&type=style&index=0&id=5c3985b6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c3985b6"]])

export default __exports__